import parse from 'html-react-parser';
import { applyRulesToReactTree } from '@/app_lib/htmlParser/inserter/inserter';
import { insertionRules } from '@/app_lib/htmlParser/inserter/rules/helpers';
import type { ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';
import { options } from '@/app_lib/htmlParser/parsers/parserOptions';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

export const DescriptionParser = ({ className, content }: { className?: string; content: string }) => {
  return <span className={cn('description-parser contents', className)}>{parse(content)}</span>;
};

export const ContentParser = ({ content, rules = [] }: { content: string; rules?: ParserRule[] }) => {
  const parsedContent = parse(content, options);
  const insertedContent = applyRulesToReactTree({
    elements: parsedContent,
    rules: [...insertionRules, ...rules],
  });
  return (
    <article
      className={cn('article-content')}
      data-cy={ContentPlacement.ArticleContent}
    >
      {insertedContent}
    </article>
  );
};
